<div class="card-container-grey card" [class.card-container-active]="active">
  <div class="date">
    <p class="text-subtitle-bold" *ngIf="appointmentNote.createdAt | isToday; else notToday"> HOY </p>
    <ng-template #notToday>
      <p class="text-subtitle-bold">{{ appointmentNote.createdAt | date }}</p>
    </ng-template>
    <div class="meal-plan-card-options d-flex">
      <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Asignar nota a una cita" class="icon-action tw-mr-2" *ngIf="(allowToAssign || allowToAssignToService) && this.canInteract"
           (click)="onAssignToAppointmentOrService($event)">
        <span nz-icon nzType="check-square" nzTheme="outline"></span>
      </div>
      <div nz-dropdown
           [nzDropdownMenu]="menu"
           class="icon-action tw-mr-2"
           *ngIf="userLogged._id === appointmentNote?.creator?._id"
           (click)="$event.preventDefault(); $event.stopPropagation()">
        <span nz-icon nzType="share-alt" nzTheme="outline"></span>
      </div>
      <div *ngIf="this.canInteract" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onDelete($event)">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
    </div>
  </div>
  <div class="content">
    <p class="text-regular-14" [innerHTML]="appointmentNote.note | sanitizerHtml">
    </p>
    <div class="gradient"></div>
  </div>
  <div class="options" [ngClass]="[userLogged.patients ? 'tw-justify-end' : 'tw-justify-between']">
    <p class="text-info" *ngIf="appointmentNote.patientCanView && !userLogged.patients">Compartido</p>
    <div class="registered-by text-regular-12">
      <p class="text-info-bold-xs">REGISTRADO POR </p>
      <app-avatar-group [users]="[appointmentNote.creator]" [numberVisibleElements]="1"></app-avatar-group>
    </div>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item *ngIf="!appointmentNote.patientCanView" (click)="onEmitChangeSharedWithPatient()">Compartir la nota con el paciente</li>
    <li nz-menu-item *ngIf="appointmentNote.patientCanView" (click)="onEmitChangeSharedWithPatient()">Dejar de compartir la nota</li>
  </ul>
</nz-dropdown-menu>

<ng-template #tplModalSelectAppointment>
  <p class="mb-md mt-xlg text-info">
    Puedes seleccionar a que cita asignar la nota
  </p>
  <app-card-meal-plan-to-appointment [appointments]="appointmentsToAssign" (selected)="appointmentIdToAssign= $event"></app-card-meal-plan-to-appointment>
</ng-template>
